// extracted by mini-css-extract-plugin
export var leadership = "Leadership-module--leadership--KnyA1";